import addToCartFromQuery from './addToCartFromQuery'

export default {
  addToCartFromQuery
}
